import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import animateScrollTo from 'animated-scroll-to';
import cx from 'classnames';

import Header from 'app/components/common/Header';
import Sidebar from 'app/components/common/Sidebar';
import Footer from 'app/components/common/Footer';
import { useBreadcrumbs } from 'app/context/BreadcrumbsContext';
import Breadcrumbs from 'app/components/common/Breadcrumbs';

import s from './BaseLayout.module.sass';

const BaseLayout: React.FC = ({
  children,
}) => {
  const { pathname } = useLocation();
  const { breadcrumbs } = useBreadcrumbs();

  useEffect(() => {
    animateScrollTo(window.pageYOffset - window.pageYOffset,
      { speed: 500, maxDuration: 1000, minDuration: 100 });
  }, [pathname]);

  return (
    <main className={cx(s.layout)}>
      <Sidebar />

      <Header className={cx(s.mobileVersion)} />

      <div className={cx(s.wrapper, { [s.paddingTop]: !breadcrumbs })} id="baseLayout">
        <Header className={cx(s.desktopVersion)} />
        {breadcrumbs && (
        <Breadcrumbs
          data={breadcrumbs}
          className={cx(s.breadcrumbs, s.mobileVersion)}
        />
        )}

        {children}
      </div>

      <Footer />
    </main>
  );
};
export default BaseLayout;
